
import { Component, Vue, Watch } from 'vue-property-decorator';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { BlockStore, CommonStore, FarmStore } from '@/store/modules';
import { FloweringBatchUpload } from '@/store/models/flowering';

@Component({
  components: {
    QvSelect,
    ValidationObserver,
    ValidationProvider
  }
})
export default class ImportBlockForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  data: FloweringBatchUpload = {} as FloweringBatchUpload;
  uploadingBlocks = false;

  get importBlockDialogVisible() {
    return BlockStore.ImportBlockDialogVisible;
  }
  set importBlockDialogVisible(value: boolean) {
    BlockStore.setImportBlockDialogVisible(value);
  }

  get farms() {
    return FarmStore.Farms.map(x => {
      return { value: x.id, label: x.name };
    });
  }

  get selectedFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  @Watch('selectedFarmBlock', { deep: true })
  onSelectedFarmBlockChange() {
    this.data.farm = this.selectedFarmBlock.farmId;
  }

  @Watch('importBlockDialogVisible')
  onImportBlockDialogVisible() {
    this.onSelectedFarmBlockChange();
  }

  async onSubmit() {
    this.uploadingBlocks = true;
    // eslint-disable-next-line
    const formData = new FormData();
    for (const key in this.data) {
      // eslint-disable-next-line
      formData.append(key, (this.data as any)[key]);
    }
    BlockStore.importBlocks({ data: formData })
      .then(() => {
        this.$q.notify({
          type: 'positive',
          message: `Blocks imported successfully`,
          timeout: 5000
        });
        this.importBlockDialogVisible = false;
      })
      .finally(() => {
        this.$emit('importCompleted');
        this.uploadingBlocks = false;
      });
  }
  onReset() {
    this.data = {} as FloweringBatchUpload;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }

  async created() {
    await FarmStore.getAllMyFarms();
    this.onSelectedFarmBlockChange();
  }
}
